import React from 'react'
import classNames from 'classnames'
import styles from './Scrim.module.scss'

type ScrimOverlayProps = React.HTMLAttributes<HTMLDivElement> & {
  active?: boolean
  layer?: number
}

const ScrimOverlay = (props: ScrimOverlayProps) => {
  const { active, layer, ...other } = props

  return (
    <div
      className={classNames(styles.scrim, active ? styles.active : styles.inactive)}
      style={{
        zIndex: layer ?? -1,
      }}
      {...other}
    />
  )
}

export default ScrimOverlay
